import { ComponentProps, PropsWithChildren } from 'react';
import { useCalendarDragState } from '../calendar-grid/calendar-drag-state-context';

export const ColumnHeaderWrapper = ({
  children,
  containerStyle,
  ...rest
}: PropsWithChildren<ComponentProps<'div'>> & {
  containerStyle?: any;
}) => {
  const { isColumnHeaderDragOverlay, columnHeaderDragOverlayStyle, isColumnHeaderOverlay, columnHeaderOverlayStyle } =
    useCalendarDragState();

  return (
    <div
      css={[
        { width: '100%' },
        containerStyle,
        isColumnHeaderOverlay && columnHeaderOverlayStyle,
        isColumnHeaderDragOverlay && columnHeaderDragOverlayStyle,
      ]}
      {...rest}
    >
      {children}
    </div>
  );
};
